@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

@font-size: 14px;
@input-height: 32px;

.create-label-content-presets {
  padding: 0 30px;
}

.rate-calculator-fulfillment-configuration {
  padding: 15px 30px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  row-gap: 10px;
  font-size: @font-size;
  background: @create-label--fulfillment--background-color;

  > .label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    min-height: 20px;
    text-align: right;
    max-width: 100px;

    &.error {
      color: @create-label--fulfillment--error--text-color;
    }
  }

  .aligned-with-input {
    height: @input-height;
    line-height: 1.2;
  }

  .lable-with-helper-text {
    height: calc(100% - 24px);
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .weight {
    display: flex;
    min-width: 0;

    .weight-input {
      width: 58px;
    }

    .scale {
      width: 78px;
    }
  }

  .size-and-weight-container {
    grid-column: ~'2 / 4';
    padding-right: 5px;
  }

  .confirmation {
    width: 185px;
  }

  .insurance-option {
    width: 185px;
  }

  .insurance-promo {
    grid-column: 1 / 3;
  }

  .insurance-amount {
    height: 34px;

    input {
      line-height: unset;
      padding-top: 10px;
      padding-bottom: 10px;

      &:focus {
        border-color: @create-label--fulfillment-input--focus--border-color;
      }
    }
  }

  .error-container {
    grid-column: 1 / span 3;
  }

  .rate {
    font-size: 16px;
    grid-column: 1;
  }
}

.size-input {
  min-width: 48px;
}

.rate-wrapper {
  padding: 0 0 10px 10px;
}

.return-label-dispatcher-wrapper {
  border-top: 1px solid @create-label--fulfillment-return--border-color;
  padding: 5px 15px 10px;
}

.package-content-description-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .info-icon {
    height: 16px;
    width: 16px;
    color: var(--default--icon--fill-color--1);
  }
}

.insurance-promo-header {
  /*we're using a non-standard size here to avoid text wrap*/
  font-size: 12.5px;
}

.insurance-row-in-promo {
  align-items: center;
  padding-bottom: @space-8;
}

.insurance-label-in-promo {
  flex-shrink: 0;
  width: 85px;
  padding-right: @space-8;
}

.insurance-input-in-promo {
  flex: 1;
  min-width: 0;
}
